import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import authService from '../services/authService'

const ChangePasswordPage: React.FC = () => {
  const navigate = useNavigate()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!currentPassword) {
      Swal.fire({ icon: 'warning', title: 'กรุณากรอกรหัสผ่านเดิม' })
      return
    }
    if (newPassword.length < 6) {
      Swal.fire({ icon: 'warning', title: 'รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร' })
      return
    }
    if (newPassword !== confirmPassword) {
      Swal.fire({ icon: 'warning', title: 'รหัสผ่านไม่ตรงกัน กรุณาตรวจสอบอีกครั้ง' })
      return
    }

    setIsSubmitting(true)
    try {
      const result = await authService.changePassword(currentPassword, newPassword)
      if (!result.success) {
        throw new Error(result.error || 'เกิดข้อผิดพลาด กรุณาลองใหม่')
      }
      await Swal.fire({
        icon: 'success',
        title: 'เปลี่ยนรหัสผ่านสำเร็จ',
        text: 'กรุณาเข้าสู่ระบบใหม่ด้วยรหัสผ่านใหม่'
      })
      await authService.logout()
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
      navigate('/login', { replace: true })
    } catch (err: any) {
      const message = err?.response?.message || err?.response?.error || err?.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่'
      await Swal.fire({ icon: 'error', title: 'เปลี่ยนรหัสผ่านไม่สำเร็จ', text: message })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <Link to="/dashboard" className="txt-link-d">
                      <i className="fas fa-chevron-left me-1"></i>
                      หน้าหลัก
                    </Link>
                  </div>
                </div>

                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-7">
                    <div className="bdr-5 bgc-4 c-red px-2 py-1 fs-18 t-medium mb-2">
                      <i className="fas fa-key me-2"></i>
                      เปลี่ยนรหัสผ่าน
                    </div>

                    <div className="bdr-5 bgc-4 c-red p-2">
                      <form onSubmit={handleSubmit}>
                        <div className="bgc-7 p-2 bdr-5 mb-2">
                          <label htmlFor="currentPassword" className="form-label c-dark">
                            รหัสผ่านเดิม
                          </label>
                          <input
                            type="password"
                            id="currentPassword"
                            className="input-show border-0 bdr-5 form-control bgc-4 c-dark"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder="กรอกรหัสผ่านเดิม"
                            autoComplete="current-password"
                            required
                          />
                        </div>

                        <div className="bgc-7 p-2 bdr-5 mb-2">
                          <label htmlFor="newPassword" className="form-label c-dark">
                            รหัสผ่านใหม่
                          </label>
                          <input
                            type="password"
                            id="newPassword"
                            className="input-show border-0 bdr-5 form-control bgc-4 c-dark"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="กรอกรหัสผ่านใหม่ (อย่างน้อย 6 ตัวอักษร)"
                            autoComplete="new-password"
                            minLength={6}
                            required
                          />
                        </div>

                        <div className="bgc-7 p-2 bdr-5 mb-2">
                          <label htmlFor="confirmPassword" className="form-label c-dark">
                            ยืนยันรหัสผ่านใหม่
                          </label>
                          <input
                            type="password"
                            id="confirmPassword"
                            className="input-show border-0 bdr-5 form-control bgc-4 c-dark"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="กรอกรหัสผ่านใหม่อีกครั้ง"
                            autoComplete="new-password"
                            minLength={6}
                            required
                          />
                        </div>

                        <button
                          type="submit"
                          className="check-button w-100 bgg-1 bdc-1 c-white"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'กำลังบันทึก...' : 'บันทึก'}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangePasswordPage
